import { ApplicationView } from '@shared/enums';
import { isDefaultView } from '@shared/utils/applications';

import { ApplicationItem, Customer } from '@widgets/cabinet/applicationCard/types';

import { useCustomerDescription } from './useCustomerDescription';
import { useIsSpecificLanguage } from './useIsSpecificLanguage';

export function useSantaClausLetterCustomerDescription(
  customer: Customer,
  items: ApplicationItem[],
  view: ApplicationView,
) {
  const isUkLanguage = useIsSpecificLanguage('uk');
  const customerDescription = useCustomerDescription(customer);

  const letterDetails = Array.isArray(items) && typeof items[0]?.details === 'object' ? items[0].details : null;
  if (isDefaultView(view) || !letterDetails) {
    return customerDescription;
  }

  const { text, translatedText } = letterDetails;
  const letterText = isUkLanguage ? text : translatedText;

  return letterText || customerDescription;
}
